import React from 'react';
import OverWindow from '../TabList/EditOverWindow';
import DialogFooter from './DialogFooter';

// A window with a body (the children) and a footer: a message on the left, the buttons on the right. It closes
// from its X or Esc without asking, which suits confirmations and results; a window that edits data sets
// hasUnsavedChanges while something typed would be lost, and the X and Esc then ask first, as the edit wizard does.
export default function DialogWindow({
  title = '',
  eyebrow = null,
  iconName = 'fa-solid fa-window-maximize',
  compact = true,
  errorText = null,
  warningText = null,
  buttons = null,
  hasUnsavedChanges = false,
  onClose = () => {},
  children = null,
}) {
  return (
    <OverWindow
      clickOnCancel={onClose}
      shouldConfirmCancel={() => hasUnsavedChanges}
      closeOnClickOutside={false}
      title={title}
      eyebrow={eyebrow}
      iconName={iconName}
      compact={compact}
    >
      <div className='EditPanelInput'>
        <div className='container-fluid'>{children}</div>
      </div>
      <DialogFooter
        errorText={errorText}
        warningText={warningText}
      >
        {buttons}
      </DialogFooter>
    </OverWindow>
  );
}
